import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';

import ProcedureStepTaskListingRenderer from '../procedures/ProcedureStepTaskListingRenderer';

export default class RecipeStepTaskListingRenderer extends ProcedureStepTaskListingRenderer<ListingRendererType.RECIPE_STEP_TASK> {
  listingRendererType = ListingRendererType.RECIPE_STEP_TASK;

  constructor() {
    super(ProcessClientOrigin.RECIPES);
  }
}
